import React from "react";
import { 
  closeAllMenuItems, 
  useCloseSubcategory, 
  useOpenSubcategoryId,
} from "src/components/side-menu/side-menu-store";
import ArrowIcon from "src/components/icons/ArrowIcon";
import { useTranslation } from "gatsby-plugin-react-i18next";
import clsx from "clsx";

interface IBackButtonProps {
  className?: string;
}

const BackButton = ({ className }: IBackButtonProps) => {
  const { t } = useTranslation("menu");
  const isSubcategoryOpen = useOpenSubcategoryId() != null
  const closeSubcategory = useCloseSubcategory()

  return (
    <button
      style={{ height: '3rem', marginLeft: '-5px', width:'230px' }}
      type='button'
      className={clsx(
        'text-almostBlackBlue bg-white flex items-center w-full py-4 px-5 border-t', 
        className
      )}
      onClick={() => {
        if (isSubcategoryOpen) {
          closeSubcategory()
        } else {
          closeAllMenuItems()
        }
      }}>
      <ArrowIcon rotate='left' color='almostBlackBlue' />
      <span className='ml-1 text-almostBlackBlue uppercase font-bold text-base'>
        {t("Go back")}
      </span>
    </button>
  );
};

export default BackButton;
